function shouldRedirectToModule({ input, output }) {
  if (input.result.redirect) {
    output.true()
  } else {
    output.false({ nextPage: 'done' })
  }
}

shouldRedirectToModule.outputs = ['true', 'false']
export default shouldRedirectToModule



// WEBPACK FOOTER //
// ./src/modules/login/actions/shouldRedirectToModule.js